import { useQuery } from "react-query";
import { fetchWorkspaces } from "@/services/workspaces";
import { WorkspacePermission } from "@/constants/workspace";

/** Query hook for the workspaces the current user may upload patient scans to. */
export function useUploadWorkspaces() {
  return useQuery(["workspaces", "upload"], function () {
    return fetchWorkspaces(WorkspacePermission.PatientUpload);
  }, {
    staleTime: Infinity,
    cacheTime: Infinity
  });
}